<style>
.tcplayer {
  margin: 0 auto;
}
/* 通过 css 设置播放器尺寸 这时<video>中的宽高属性将被覆盖*/
.player-size {
  width: 640px;
  height: 360px;
}
@media screen and (max-width: 640px) {
  .player-size {
    width: 100%;
    height: 270px;
  }
}
/* 设置logo在高分屏的显示样式 */
@media only screen and (min-device-pixel-ratio: 2), only screen and (-webkit-min-device-pixel-ratio: 2) {
  .tcp-logo-img {
    width: 50%;
  }
}
</style>
<template>
  <div>
    <van-nav-bar v-if="!fullScreenStatus" style="background-color: #42b983">
      <template #title>
        <span style="color: #ffffff">在线课程学习</span>
      </template>
      <template #left>
        <van-icon name="arrow-left" color="#ffffff"/>
        <span style="color: #ffffff" @click="toBack">返回</span>
      </template>
      <template #right>
        <router-link to="/">
          <van-icon name="wap-home-o" color="#ffffff" size="1.3rem"/>
        </router-link>
      </template>
    </van-nav-bar>


    <van-row style="margin: 0 12px">

      <h3 v-if="!fullScreenStatus">
        {{ course.name }}

        &nbsp;
<!--        <van-tag v-if="2===learn_status" type="success">学习完成</van-tag>-->
<!--        <van-tag v-else-if="1 === learn_status" type="primary">学习中</van-tag>-->
<!--        <van-tag v-else type="danger">未开始学习</van-tag>-->

      </h3>

      <van-row v-if="!fullScreenStatus">

        <van-tag v-if="learn_prompt" mark type="danger">{{ learn_prompt }}</van-tag>
      </van-row>


      <video :id="tcPlayerId"
             class="player-size"
             preload="auto"
             playsinline webkit-playsinline>
      </video>


      <br>
      <van-row v-if="!fullScreenStatus">
        本节课共{{ this.formatSeconds(this.course.video_duration) }}，学习进度为:{{ this.formatSeconds(this.current_progress) }}。


        <br><br><br>
        <van-button @click="endLearn" type="info" size="small" block>结束学习</van-button>
      </van-row>

    </van-row>


    <van-dialog v-model="loading" title="" :show-confirm-button="false">
      <br>
      <van-loading size="50px" vertical>加载中...</van-loading>
      <br>
    </van-dialog>
  </div>
</template>
<script>

export default {

  data() {
    return {
      loading: true,//页面加载状态

      course_id: 0,

      course: {},
      list: [],
      learn: {},
      learn_course: {},

      fullScreenStatus: false,

      tcPlayerId: 'tcPlayer' + Date.now(),
      player: null,
      config: {
        fileID: "",
        appID: '1301658856',
        playbackRates: [],
        controls:true,
      },
      timerRecordLearnProgress: '',

      learn_status: 0,//学习状态:0未开始，1学习中,2已完成
      learn_prompt: '',//学习提示
      upload_i: 0,//上传进度的控制变量
      current_progress: '',//当前进度

      video_status_playing:false,
    }
  },
  beforeDestroy() {
    clearInterval(this.timerRecordLearnProgress);
  },
  created() {

    if (undefined === this.$route.query.course_id || "" === this.$route.query.course_id) {
      this.$route.push("/courses")
      return
    }

    this.course_id = Number(this.$route.query.course_id)
    this.getCourse()
  },

  methods: {
    //https://cloud.tencent.com/document/product/881/30824#options-.E5.8F.82.E6.95.B0.E5.88.97.E8.A1.A8
    playerInit() {
      this.player = window.TCPlayer(this.tcPlayerId, this.config);

      //已经开始播放，调用 play() 方法或者设置了 autoplay 为 true 且生效时触发，这时 paused 属性为 false。
      this.player.on('play',()=>{
        console.log("【事件】play")
        // this.video_status_playing=false;
      });
      //因缓冲而暂停或停止后恢复播放时触发，paused 属性为 false 。通常用这个事件来标记视频真正播放，play 事件只是开始播放，画面并没有开始渲染。
      this.player.on('playing',()=>{
        console.log("【事件】playing")
        this.video_status_playing=true;
      });
      this.player.on('pause',()=>{
        console.log("【事件】pause")
        this.video_status_playing=false;
      });
      this.player.on('waiting',()=>{
        console.log("【事件】waiting")
        this.video_status_playing=false;
      });
      this.player.on('ended',()=>{
        console.log("【事件】ended")
        this.video_status_playing=false;
      });

      // this.player.on('timeupdate',()=>{
      //   console.log("【事件】timeupdate",this.course.video_duration)
      //   if (this.video_status_playing && this.current_progress+3<this.player.currentTime()){
      //     this.player.currentTime(this.current_progress)
      //   }
      //
      //   //*苹果某款手机播放途中点击home键返回桌面后再回到播放页，直接从开始播放的地方开始了~他实现了漏洞快进*所以在这里也加了一个限制快进~
      //   // if(maxLen < this.player.currentTime){
      //     // maxLen = this.player.currentTime;
      //   // }
      //   //本地存储播放时长，解决保存失败的问题
      //   // localStorage.maxlen = this.player.currentTime;
      // });

      if (this.current_progress >= this.course.video_duration) {
        this.learn_status = 2;
        return;
      }

      console.log("当前时间:",this.learn_course.current_progress)
      this.player.currentTime(this.learn_course.current_progress);

      this.startTimerRecordLearnProgress();
    },
    getCourse() {
      this.$http.get("/wechat/learn/course", {
        params: {
          course_id: this.course_id
        }
      }).then(res => {
        this.loading = false
        console.log(res.data);
        if (2101 === res.data.code) {
          this.$dialog.alert({title: '需要完善资料', message: res.data.msg}).then(() => {
            this.$router.push('/courses');
          });
          this.$dialog.confirm({
            title: '需要完善资料',
            message: res.data.msg,
            confirmButtonText: "去完善",
            cancelButtonText: "退出"
          }).then(() => {
            this.$router.push('/user/edit');
          }).catch(() => {
            this.$router.push('/courses');
          });
          return
        }

        if (2202 === res.data.code) {
          this.$dialog.confirm({
            title: '未充值提示',
            message: res.data.msg,
            confirmButtonText: "去充值",
            cancelButtonText: "退出"
          }).then(() => {
            this.$router.push('/buy');
          }).catch(() => {
            this.$router.push('/courses');
          });
          return;
        }

        if (200 !== res.data.code) {
          this.$dialog.alert({title: '学习失败', message: res.data.msg}).then(() => {
            this.$router.push('/courses');
          });
          return
        }

        this.learn = res.data.data.learn
        this.learn_course = res.data.data.learn_course
        this.course = res.data.data.course
        this.current_progress = Number(this.learn_course.current_progress)


        this.config.fileID = res.data.data.course.video_no
        // this.config.fileID = "5285890809346843260"

        this.playerInit()
      });
    },

    startTimerRecordLearnProgress() {
      console.log("开始startTimerRecordLearnProgress")
      var that = this
      this.timerRecordLearnProgress = setInterval(() => {
        that.recordLearnProgress()
      }, 2000);
    },
    recordLearnProgress() {
      console.log(this.video_status_playing,"video_status_playing===")


      if (!this.video_status_playing) {
        this.learn_status = 0;
        return
      }

      console.log("this.upload_i", this.upload_i)

      //视频学习完成
      if (this.course.video_duration <= this.current_progress) {
        this.learn_status = 2;
        if (0 !== this.upload_i && this.upload_i <= 10) {
          this.uploadCurrentProgress()
          return;
        }
        return;
      }


      if (this.current_progress > this.player.currentTime()) {
        this.learn_status = 0;
        this.learn_prompt = "您上次听课听到" + this.formatSeconds(this.current_progress)
            + "请手动将进度条移动至" + this.formatSeconds(this.current_progress) + "处,开始学习计时。";
        return
      } else if (this.current_progress+30<this.player.currentTime()){
        this.learn_prompt = "您上次听课听到" + this.formatSeconds(this.current_progress)
            + "请手动将进度条移动至" + this.formatSeconds(this.current_progress) + "处,开始学习计时。";
      } else {
        this.learn_prompt = ""
      }


      this.current_progress = this.current_progress + 2
      this.upload_i++

      this.learn_status = 1;
      this.learn_status_test = "当前状态:正在学习";

      if (this.upload_i <= 10) {
        //控制上传进度的间隔
        return;
      }
      this.uploadCurrentProgress()

    },
    uploadCurrentProgress() {
      this.$http.get("/wechat/learn/course/record", {
        params: {
          current_progress: this.current_progress,
          course_id: this.course.id
        }
      }).then(res => {
        this.upload_i = 0
        console.log(res.data);
      });
    },

    endLearn() {
      clearTimeout(this.timerRecordLearnProgress);
      this.uploadCurrentProgress()
      this.$http.get("/wechat/learn/end/" + this.learn.id).then(res => {
        console.log(res.data);
      });
      this.$router.push('/courses');
    },

    toBack() {
      this.$dialog.confirm({
        title: '确定要退出吗',
        message: '确定要退出吗？',
      }).then(() => {
        this.endLearn()

      }).catch(() => {
        // on cancel
      });
    },
    formatSeconds(value) {
      let result = parseInt(value)
      let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
      let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
      let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));

      let res = '';
      if (h !== '00') res += `${h}小时`;
      if (m !== '00') res += `${m}分`;
      res += `${s}秒`;
      return res;
    }

  }

}
</script>
